const english = {
    'COLLECTION.Button_Create' : 'New collection',
    'COLLECTION.Modal_Title_Create' : 'Create collection',
    'COLLECTION.Title_EditCollection' : 'Edit Collection',
    'COLLECTION.Type_Private' : 'private',
    'COLLECTION.Type_Public' : 'public',
    'COLLECTION.Text_YourDefault' : 'Your default private collection',
    'COLLECTION.Link_Text_Edit' : 'Edit collection',
    'COLLECTION.Modal_Title_Remove' : 'Remove collection',
    'COLLECTION.Button_Delete' : 'Delete collection',
    'COLLECTION.Text_ModalDelete_Question' : 'Are you sure you want to delete this collection?',
    'COLLECTION.Title_Default' : 'Default collection',
    'COLLECTION.Text_PostCount' : '{ postCount } posts',
    'COLLECTION.Text_YourCollection' : 'Your collection',
    'COLLECTION.Modal_Title_AddPost' : 'Add to collection',
    'FOLLOW.Button_Text_Follow' : 'Follow',
    'FOLLOW.Button_Text_Unfollow' : 'Unfollow',
    'FOLLOW.Button_Text_Following' : 'Following',
    'FOLLOW.Button_Text_FollowCollection' : 'Follow Collection',
    'FOLLOW.Button_Text_UnfollowCollection' : 'Unfollow Collection',
    'FOLLOW.Button_Text_FollowHashtag' : 'Follow Hashtag',
    'FOLLOW.Button_Text_UnfollowHashtag' : 'Unfollow Hashtag',
    'FOLLOW.Type_Label_Collections' : '{ icon } Collections',
    'FOLLOW.Type_Label_Users' : '{ icon } Users',
    'FOLLOW.Type_Label_Hashtags' : '{ icon } Hashtags',
    'FORM_RULES.Required_Username' : 'Please input your Username!',
    'FORM_RULES.Required_Password' : 'Please input your Password!',
    'FORM_RULES.Email' : 'The input is not valid E-mail',
    'FORM_RULES.Required_Email' : 'Please input your Email',
    'FORM_RULES.Min_FullName' : 'Full name must be at least { minLength } characters',
    'FORM_RULES.Required_FullName' : 'Please input your Full name',
    'FORM_RULES.Min_Username' : 'Username must be at least { minLength } characters',
    'FORM_RULES.RegExp_Username' : 'May contain only small letters, "-", "_", "."',
    'FORM_RULES.Min_Password' : 'Password must be at least { minLength } characters',
    'FORM_RULES.Required_NewPassword' : 'Please input new Password',
    'FORM_RULES.Required_Gender' : 'Please select your gender',
    'FORM_RULES.Required_Salutation' : 'Please select salutation',
    'FORM_RULES.Required_Language' : 'Please select language',
    'FORM_RULES.ContactPhone' : 'May contain only digits, "+", "-", " "',
    'FORM_RULES.Required_CurrentPassword' : 'Please input your current password',
    'FORM_RULES.Required_ConfirmPassword' : 'Please confirm Password',
    'FORM_RULES.Required_PasswordInconsistent' : 'Two passwords that you enter is inconsistent!',
    'FORM_RULES.Text_UploadImage' : 'Upload high-quality file less than { size } Mb.{ br }More files you can add on edit post step.',
    'FORM_RULES.Attachment_Size' : 'Upload any files less than { size } Mb each',
    'FORM_RULES.Required_CollectionSlug' : 'Please input collection slug',
    'FORM_RULES.Min_CollectionSlug' : 'Slug must be at least  { minLength } characters',
    'FORM_RULES.RegExp_CollectionSlug' : 'May contain only small letters, numbers, "-", "_"',
    'FORMS.Title_Login' : 'Sign in',
    'FORMS.Input_Label_Username' : 'Username',
    'FORMS.Input_Label_Password' : 'Password',
    'FORMS.Button_Text_Login' : 'Sign in',
    'FORMS.Text_Registration_Question' : 'New user?',
    'FORMS.Link_Text_Registration' : 'Sign up',
    'FORMS.Link_Text_ForgotPassword' : 'Forgot password?',
    'FORMS.Link_Text_ForgotPassword2' : 'Send',
    'FORMS.Link_Text_Login' : 'Sign In',
    'FORMS.Title_Registration' : 'Sign up',
    'FORMS.Input_Label_Email' : 'Email',
    'FORMS.Input_Label_FullName' : 'Full name',
    'FORMS.Button_Text_Register' : 'Sign up',
    'FORMS.Text_Login_Question' : 'Have an account?',
    'FORMS.Button_Text_ForgotPassword' : 'Send Forgot Link',
    'FORMS.Title_ForgotPassword' : 'Forgot password',
    'FORMS.Success_Text_ForgotPassword' : 'We sent you the password recovery link in your email!',
    'FORMS.Input_Label_NewPassword' : 'New password',
    'FORMS.Title_ChangePassword' : 'Change password',
    'FORMS.Text_ChangePassword_Question' : 'Remember your password?',
    'FORMS.Text_ForgotPassword_Question' : 'Send new request?',
    'FORMS.Loading_Text_ChangePassword' : 'Please wait, we are check your token',
    'FORMS.Select_OptionLabel_Male' : 'Male',
    'FORMS.Select_OptionLabel_Female' : 'Female',
    'FORMS.Select_OptionLabel_Mrs': 'Mrs.',
    'FORMS.Select_OptionLabel_Mr': 'Mr.',
    'FORMS.Select_OptionLabel_CEO': 'Chief Executive Officer',
    'FORMS.Select_OptionLabel_CSellingOwner': 'Co-selling owner',
    'FORMS.Select_OptionLabel_BranchManager': 'Branch manager',
    'FORMS.Select_OptionLabel_SalesManager': 'Sales Manager',
    'FORMS.Select_OptionLabel_CertifiedCarSalesman': 'Certified car salesman',
    'FORMS.Select_OptionLabel_Salesperson': 'Salesperson',
    'FORMS.Select_OptionLabel_ServiceConsultant': 'Service consultant',
    'FORMS.Select_OptionLabel_OwnerShareholder': 'Owner / Shareholder',
    'FORMS.Select_OptionLabel_CarMaster': 'Car Master',
    'FORMS.Select_OptionLabel_Marketing': 'Marketing',
    'FORMS.Input_Label_CompanyName': 'Company name',
    'FORMS.Input_Label_DealerNumber': 'Dealer number',
    'FORMS.Input_Label_Dealer': 'Dealer',
    'FORMS.Input_Label_City': 'City',
    'FORMS.Input_Label_ZipCode': 'Zip code',
    'FORMS.Input_Label_Street': 'Street',
    'FORMS.Input_Label_Region': 'Region',
    'FORMS.Input_Label_District': 'District',
    'FORMS.Select_Label_Gender' : 'Gender',
    'FORMS.Select_Label_Salutation' : 'Salutation',
    'FORMS.Input_Placeholder_Choose': 'Please Choose',
    'FORMS.Select_Label_Language' : 'Language',
    'FORMS.Textarea_Label_About' : 'About',
    'FORMS.Input_Placeholder_FullName' : 'Enter your Full name',
    'FORMS.Input_Placeholder_Username' : 'Enter your Username',
    'FORMS.Input_Placeholder_Email' : 'Enter your E-Mail',
    'FORMS.Input_Placeholder_Gender' : 'Select your gender',
    'FORMS.Input_Placeholder_Language' : 'Select your Language',
    'FORMS.Input_Placeholder_About' : 'Write something about you',
    'FORMS.Input_Placeholder_ContactEmail' : 'Enter your contact Email',
    'FORMS.Input_Placeholder_ContactPhone' : 'Enter your contact phone',
    'FORMS.Input_Placeholder_Phone' : 'Enter your phone',
    'FORMS.Input_Label_ContactPhone' : 'Contact phone',
    'FORMS.Input_Label_Phone' : 'Phone',
    'FORMS.Input_Label_JobTitle': 'Job title',
    'FORMS.Input_Label_DateBirth': 'Date of birth',
    'FORMS.Input_Label_DateEntrance': 'Date of entrance',
    'FORMS.Input_Label_SellerNumber': 'Seller number',
    'FORMS.Input_Label_ContactEmail' : 'Contact E-Mail',
    'FORMS.Button_Text_ChangePassword' : 'Change password',
    'FORMS.Input_Placeholder_CurrentPassword' : 'Enter your current password',
    'FORMS.Input_Placeholder_NewPassword' : 'Enter new password',
    'FORMS.Input_Placeholder_ConfirmPassword' : 'Repeat new password',
    'FORMS.Input_Label_CurrentPassword' : 'Old Password',
    'FORMS.Input_Label_ConfirmPassword' : 'Type it again',
    'FORMS.Input_Label_Title' : 'Title',
    'FORMS.Input_Label_Description' : 'Description',
    'FORMS.Input_Label_CollectionName' : 'Collection name',
    'FORMS.Upload_Label_Cover' : 'Cover',
    'FORMS.Input_Label_CollectionUniqueName' : 'Collection unique name',
    'FORMS.Checkbox_Label_CollectionPublic' : 'Make this collection public',
    'FORMS.Input_Placeholder_Slug' : 'Unique name for URL',
    'GLOBAL.Select_OptionLabel_NotProvided': 'Not provided',
    'GLOBAL.Button_Text_Confirm' : 'Confirm',
    'GLOBAL.Button_Text_Yes' : 'Yes',
    'GLOBAL.Button_Text_No' : 'No',
    'GLOBAL.Text_InactiveUser' : 'Inactive user',
    'GLOBAL.Button_Text_Cancel' : 'Cancel',
    'GLOBAL.Text_ItsYou' : 'It\'s you',
    'GLOBAL.Link_Text_EditProfile' : 'Edit profile',
    'GLOBAL.Title_EditProfile' : 'Edit Profile',
    'GLOBAL.Button_Text_ChangePhoto' : 'Change photo',
    'GLOBAL.Button_Text_Save' : 'Save',
    'GLOBAL.Title_AdditionalInfo' : 'Additional Info',
    'GLOBAL.Title_ChangePassword' : 'Change password',
    'GLOBAL.Button_Text_Next' : 'Next',
    'GLOBAL.Button_Text_Publish' : 'Publish',
    'GLOBAL.Button_Text_SaveDraft' : 'Save as draft',
    'GLOBAL.Button_Text_Done' : 'Done',
    'GLOBAL.Button_Text_Send' : 'Send',
    'GLOBAL.Button_Text_Create' : 'Create',
    'GLOBAL.Button_Text_ChangeCover' : 'Change cover',
    'GLOBAL.Link_Text_OnError' : 'Go to timeline',
    'GLOBAL.Title_Followers' : '{ slug } followers',
    'GLOBAL.Title_Following' : '{ slug } following',
    'GLOBAL.Link_Text_OnDraftError' : 'Go to all drafts',
    'GLOBAL.Text_SystemError' : 'Sorry something went wrong. Please try to reload page or contact with administrator.',
    'GLOBAL.Link_Text_SystemError' : 'Back home',
    'GLOBAL.Text_Loading' : 'LOADING…',
    'GLOBAL.Button_Text_More' : 'more',
    'USER.Request_Text1' : 'Dear club member,',
    'USER.Request_Text2' : 'if you have any support or questions.{ br }',
    'USER.Request_Text3' : 'You can contact us at any time by e-mail! Please use our mail form below.',
    'USER.Request_Text_Result' : 'Thank you for your inquiry, we will get back to you as soon as possible.',
    'USER.Request_Input_Placeholder' : 'Message',
    'MENUS.Label_News' : 'News',
    'MENUS.Label_MyTimeline' : 'My Timeline',
    'MENUS.Label_Search' : 'Search',
    'MENUS.Label_Profile' : 'Profile',
    'MENUS.Label_NewPost' : 'New Post',
    'MENUS.Button_Text_CopyLink' : 'Copy link',
    'MENUS.Button_Text_Repost' : 'Repost',
    'MENUS.Button_Text_Cancel' : 'Cancel',
    'MENUS.Label_EditPost' : 'Edit Post',
    'MENUS.Label_DeletePost' : 'Delete Post',
    'MENUS.Link_Text_GoCollection' : 'Go to Collection',
    'MENUS.Link_Text_GoHashtag' : 'Go to Hashtag',
    'MENUS.Label_Posts' : 'Posts',
    'MENUS.Label_DraftPosts' : 'Drafts',
    'MENUS.Label_Collections' : 'Collections',
    'MENUS.Label_Documents' : 'Documents',
    'MENUS.Label_Users' : 'Users',
    'MENUS.Label_Hashtags' : 'Hashtags',
    'MENUS.Label_Following' : 'Following',
    'MENUS.Label_Followers' : 'Followers',
    'MENUS.Label_EditProfile' : 'Edit profile',
    'MENUS.Label_AdditionalInfo' : 'Additional Info',
    'MENUS.Label_ChangePassword' : 'Change password',
    'MENUS.Button_Text_Logout' : 'Logout',
    'MENUS.Label_Settings' : 'Settings',
    'MENUS.Label_Dealer' : 'Dealer info',
    'MENUS.Label_EditCollection' : 'Edit Collection',
    'MENUS.Label_Notifications' : 'Notifications',
    'NO_DATA.Select_Chat' : 'Do you need support or have a question?{ br }We are looking forward to your message!',
    'NO_DATA.Text_Timeline' : 'There are no posts in your timeline',
    'NO_DATA.Link_Text_TimelineCreatePost' : 'Create first post?',
    'NO_DATA.Link_Text_TimelineSearch' : 'Find something to follow?',
    'NO_DATA.Text_Likes' : 'Nobody likes this post.',
    'NO_DATA.Text_Search_Posts' : 'We could not find Posts{ br }according to your request.',
    'NO_DATA.Text_Search_Users' : 'We could not find Users{ br }according to your request.',
    'NO_DATA.Text_Search_Hashtags' : 'We could not find Hashtags{ br }according to your request.',
    'NO_DATA.Text_Search_Collections' : 'We could not find collections{ br }according to your request.',
    'NO_DATA.Text_Search_Documents' : 'We could not find documents{ br }according to your request.',
    'NO_DATA.Text_Notifications_All' : 'You have no notifications',
    'NO_DATA.Text_Notifications_Unread' : 'You have no unread notifications',
    'NO_DATA.Link_Text_UserCreatePost' : 'Create new post?',
    'NO_DATA.Text_UserPosts' : '{ who } have no Posts yet',
    'NO_DATA.Text_UserDraftPosts' : 'You have no draft posts',
    'NO_DATA.Text_UserCollections' : '{ who } have no Collections',
    'NO_DATA.Text_UserDocuments' : '{ who } have no Documents',
    'NO_DATA.Text_NewsTimeline' : 'There are no posts in the news',
    'NO_DATA.Text_Who_User' : 'User',
    'NO_DATA.Text_Who_You' : 'You',
    'NO_DATA.Text_UserFollowers' : '{ who } have no Followers',
    'NO_DATA.Text_HashtagFollowers' : 'This hashtag has no followers.',
    'NO_DATA.Text_CollectionFollowers' : 'This collection has no followers.',
    'NO_DATA.Text_HashtagFollow' : '{ who } don’t follow any hashtags',
    'NO_DATA.Text_CollectionFollow' : '{ who } don’t follow any collections',
    'NO_DATA.Text_UserFollow' : '{ who } don’t follow any users',
    'NO_DATA.Text_HashtagPosts' : 'There are no posts in this hashtag yet.',
    'NO_DATA.Text_CollectionPosts' : 'There are no posts in this collection yet.',
    'NO_DATA.Text_Search' : 'We could not find anything{ br }according to your request.',
    'NO_DATA.Text_Dealer' : 'The dealer are not assigned to your account',
    'NOTIFICATIONS.Drawer_Title' : 'Notifications',
    'NOTIFICATIONS.Filter_Label_All' : 'All',
    'NOTIFICATIONS.Filter_Label_Unread' : 'Unread',
    'POST.Text_ModalDelete_Question' : 'Are you sure you want to delete this post?',
    'POST.Button_Text_DeletePost' : 'Delete Post',
    'POST.Modal_Title_Delete' : 'Remove Post',
    'POST.Modal_Title_Share' : 'Share post',
    'POST.Button_Text_Share' : 'Share',
    'POST.Button_Text_Shared' : 'Shared',
    'POST.Button_Text_Like' : '{ likeCount } like',
    'POST.Button_Text_Likes' : '{ likeCount } likes',
    'POST.Modal_Title_Likes' : 'Likes',
    'POST.Button_Text_ViewComments' : 'View all { commentCount } comments',
    'POST.Drawer_Title_Comments' : 'Comments',
    'POST.Modal_Title_Attachments' : 'Added Files',
    'POST.Button_Text_Attachment' : '{ attachmentCount } document are added',
    'POST.Button_Text_Attachments' : '{ attachmentCount } documents are added',
    'POST.Input_Placeholder_Comments' : 'Add a comment…',
    'POST.Link_Text_ViewPost' : 'View Post',
    'POST.Link_Text_DownloadAttachment' : 'Download',
    'POST.Title_ChooseImage' : 'Choose an image',
    'POST.Text_AddImage' : 'Add image',
    'POST.Type_Post' : 'Post',
    'POST.Type_News' : 'News',
    'POST.Title_PostDetails' : 'Post Details',
    'POST.Title_CreatePost' : 'Create post',
    'POST.Title_EditPost' : 'Edit post',
    'POST.Drawer_Title_Attachments': 'Post documents',
    'POST.Drawer_Title_ManageImages' : 'Manage images',
    'POST.Title_AttachDocuments': 'Attach documents',
    'POST.Title_ManageImages' : 'Manage images',
    'POST.Dragger_Text_Attach' : 'Attach documents',
    'POST.Attachment_Count' : 'Files ({ attachmentCount })',
    'POST.Images_Count' : 'Images ({ imagesCount })',
    'POST.Avatar_NewsTitle' : 'NEWS',
    'POST.Text_Origin' : 'Original Post from: { username }',
    'SEARCH.Input_Placeholder_User' : 'Input name or username',
    'SEARCH.Input_Placeholder' : 'Start searching…',
    'SEARCH.Type_Label_News' : 'News',
    'SEARCH.Type_Label_Posts' : 'Posts',
    'SEARCH.Type_Label_Users' : 'Users',
    'SEARCH.Type_Label_Hashtags' : 'Hashtags',
    'SEARCH.Type_Label_Collections' : 'Collections',
    'SEARCH.Type_Label_Documents' : 'Documents',
    'SORT.Label_Newest' : 'Newest',
    'SORT.Label_Popular' : 'Popular',
    'SORT.Label_MostUsed' : 'Most used',
    'SORT.Label_AtoZ' : 'A to Z',
    'SUMMARY_COUNTERS.Label_KNYS' : 'KNYS',
    'SUMMARY_COUNTERS.Label_Users' : 'Users',
    'SUMMARY_COUNTERS.Label_Posts' : 'Posts',
    'SUMMARY_COUNTERS.Label_Images' : 'Images',
    'SUMMARY_COUNTERS.Label_Videos' : 'Videos',
    'SUMMARY_COUNTERS.Label_Documents' : 'Documents',
    'SUMMARY_COUNTERS.Label_Comments' : 'Comments',
    'SUMMARY_COUNTERS.Label_Collections' : 'Collections',
    'SUMMARY_COUNTERS.Label_Teams' : 'Teams',
    'SUMMARY_COUNTERS.Label_Hashtags' : 'Hashtags',
    'MENUS.Label_MyProfile' : 'My Profile',
    'FORMS.Input_Label_JobDescription' : 'Job description',
    'FORMS.Input_Placeholder_JobDescription' : 'Enter your Job description',
    'MENUS.Label_Competition' : 'COMPETITION',
    'MENUS.Label_Ranking' : 'RANKING',
    'GLOBAL.Modal_Title_Menu' : 'Menu',
    'MENUS.Label_Events' : 'EVENTS',
    'MENUS.Label_Contact' : 'CONTACT',
    'MENUS.Label_Terms' : 'WEB RULES',
    'MENUS.Label_FAQ' : "FAQ",
    'MENUS.Label_HelpAndAdvice' : 'Help & Advice',
    'MENUS.Label_Chat' : 'Chat',
    'CHAT.Button_Text_NewChat': "New Chat",
    'CHAT.Modal_Title_NewChat': "New Chat",
};

export default english;